import { classes } from '@/uiPrimitives/base/classes.helpers';
import { Dialog, DialogProps } from './Dialog.client';
import { box } from '@/uiPrimitives/layout/box';
import { sideOverlayModalCSS } from './SideOverlay.css';

export const SideOverlay = ({
	children,
	className,
	classNameInner,
	...props
}: DialogProps & { classNameInner?: string }) => {
	return (
		<Dialog {...props} className={classes(sideOverlayModalCSS, className)}>
			<div
				className={classes(
					box({
						minBlockSize: '100%',
					}),
					classNameInner,
				)}
			>
				{children}
			</div>
		</Dialog>
	);
};
